import { adapter, EMPLOYEES_FEATURE_KEY, EmployeesPartialState, EmployeesState } from './employees.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getEmployeesState = createFeatureSelector<
  EmployeesPartialState,
  EmployeesState
>(EMPLOYEES_FEATURE_KEY);

const { selectAll, selectEntities } = adapter.getSelectors();

const getError = createSelector( getEmployeesState, (state:EmployeesState) => state.error );

const getAllEmployees = createSelector(
  getEmployeesState,
  selectAll
);

const getAllEmployeesById = createSelector(
  getEmployeesState,
  selectEntities
);

const getLastCreatedId = createSelector( getEmployeesState, (state:EmployeesState) => state.lastCreatedId );

const getIsSearching = createSelector( getEmployeesState, (state:EmployeesState) => state.isSearching );

const getSearchResultIds = createSelector( getEmployeesState, (state:EmployeesState) => state.searchResultIds );

const getPagination = createSelector(getEmployeesState, (state: EmployeesState) => state.pagination);

const getQuery = createSelector(getEmployeesState, (state: EmployeesState) => state.query);

const getSearchResults = createSelector( getAllEmployeesById, getSearchResultIds, (entities, searchResultIds) => {
  return searchResultIds.map(id => entities[id]);
})

export const EmployeesQuery = {
  getError,
  getAllEmployees,
  getAllEmployeesById,
  getLastCreatedId,
  getPagination,
  getQuery,
  getIsSearching,
  getSearchResults
};
